"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SUPPORTED_FILE_SIZE = void 0;
exports.MAX_SUPPORTED_FILE_SIZE = 2 * 1024 * 1024 * 1024 - 1;
//# sourceMappingURL=common.js.map